<div class="dialog_main">
  <button class="dialog_close" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  <div class="dialog_body">
    <div class="top_title hd_5">
      <h2>{{ 'ProfileSetup' | translate }}</h2>
      <p>
       {{ 'letsgetyourprofilesetupfillinyourdetailsbelowtopersonalizeyourexperienceandgetstarteditonlytakesafewminutes'| translate}}
      </p>
    </div>
    <form [formGroup]="profileFormGroup" (ngSubmit)="onSubmit()">
      <div class="form_feilds">
        <div class="form_group text_center">
          <label class="upload_box main-prf" for="upload">
            <div class="preview">
              <figure>
                <img
                  [src]="
                    profileFormGroup.get('image')?.value
                      ? profileFormGroup.get('image')?.value
                      : assetsConst.logo
                  "
                  alt="Image" />
              </figure>
              <mat-icon
                ><img src="{{ assetsConst.pencil_icon }}" alt="Icon"
              /></mat-icon>
            </div>
            <input
              type="file"
              id="upload"
              accept="image/*"
              (change)="onFileChange($event)" />
          </label>
        </div>
        <div class="form_group">
          <mat-form-field appearance="fill">
            <input
              matInput
              placeholder="{{ 'Name' | translate }} *"
              class="form_control"
              formControlName="firstName" />

            @if (submitted) {
              @for (err of nameErrors; track $index) {
                @if (profileFormGroup.controls['firstName'].hasError(err.key)) {
                  <mat-error>{{ err.message | translate }}</mat-error>
                }
              }
            }
          </mat-form-field>
        </div>
        <div class="form_group">
          <mat-form-field appearance="fill">
            <input
              matInput
              placeholder="{{ 'Email' | translate }} *"
              class="form_control"
              formControlName="email" />

              @if (submitted) {
                @if (profileFormGroup.get('email')?.hasError('required')) {
                  <mat-error>
                    {{ 'Please fill this field' | translate }}
                  </mat-error>
                } @else if (profileFormGroup.get('email')?.hasError('email')) {
                  <mat-error>
                    {{ 'Enter a valid email address' | translate }}
                  </mat-error>
                } @else {
                  @for (err of emailErrors; track $index) {
                    @if (profileFormGroup.controls['email'].hasError(err.key)) {
                      <mat-error>{{ err.message | translate }}</mat-error>
                    }
                  }
                }
              }
              
          </mat-form-field>
          @if (data.signUpType === signUpType.Phone) {
            @if (!emailVerified && profileFormGroup.get('email')?.value) {
              <p
                class="pointer verify-btn"
                (click)="verifyField(signUpType.Email)">
                {{ 'Verify' | translate }}
              </p>
            }
          }
        </div>
        <div class="form_group">
          <mat-form-field appearance="fill">
            <div class="form_group">
              <ngx-mat-intl-tel-input
                [preferredCountries]="['ae']"
                [enablePlaceholder]="true"
                [enableSearch]="true"
                name="phone"
                describedBy="phoneInput"
                formControlName="phoneNo"
                class="phone_selector"
                maxlength="15"
                #phone
                (countryChanged)="
                  countryChangedEvent($event)
                "></ngx-mat-intl-tel-input>

              <div>
                @if (submitted) {
                  @if (
                    (profileFormGroup.get('phoneNo')?.value === '' ||
                      profileFormGroup.get('phoneNo')?.value === null) &&
                    profileFormGroup.get('phoneNo')?.hasError('required')
                  ) {
                    <mat-error
                      >{{ 'PhoneNumber' | translate }}
                      {{ 'isRequired' | translate }}</mat-error
                    >
                  }
                  @if (
                    profileFormGroup.get('phoneNo')?.value === undefined ||
                    profileFormGroup
                      .get('phoneNo')
                      ?.hasError('validatePhoneNumber')
                  ) {
                    <mat-error
                      >{{ 'PleaseEnterValid' | translate }}
                      {{ 'PhoneNumber' | translate }}
                    </mat-error>
                  }

                  <!-- @if (
                    !phoneVerified &&
                    !profileFormGroup.get('phoneNo')?.hasError('required') &&
                    !profileFormGroup
                      .get('phoneNo')
                      ?.hasError('validatePhoneNumber')
                  ) {
                    <mat-error>
                      {{ 'VerifyPhone' | translate }}
                    </mat-error>
                  } -->
                }
              </div>
            </div>
            @if (data.signUpType === signUpType.Email) {
              @if (!phoneVerified && profileFormGroup.get('phoneNo')?.value) {
                <p
                  class="pointer verify-btn"
                  (click)="verifyField(signUpType.Phone)">
                  {{ 'Verify' | translate }}
                </p>
              }
            }
          </mat-form-field>
          <small class="field-hint">{{ 'PhoneNumber' | translate }} ({{ 'Optional' | translate }})</small>
        </div>

        <ng-container formGroupName="address">
          <div class="form_group">
            <mat-form-field appearance="fill">
              <input
                #place1
                matInput
                (click)="addressChange(place1)"
                placeholder="{{ 'Address' | translate }} ({{ 'Optional' | translate }})"
                class="form_control"
                formControlName="address" />
            </mat-form-field>
            @if (submitted) {
              @if (
                profileFormGroup
                  .get('address')
                  ?.get('address')
                  ?.hasError('required')
              ) {
                <mat-error>
                  {{ 'Address' | translate }} {{ 'isRequired' | translate }}
                </mat-error>
              }
            }
          </div>
          <div class="form_group">
            <mat-form-field appearance="fill">
              <input
                matInput
                placeholder="{{ 'Country' | translate }} ({{ 'Optional' | translate }})"
                class="form_control"
                formControlName="country" />
            </mat-form-field>
            @if (submitted) {
              @if (
                profileFormGroup
                  .get('address')
                  ?.get('country')
                  ?.hasError('required')
              ) {
                <mat-error>
                  {{ 'Country' | translate }} {{ 'isRequired' | translate }}
                </mat-error>
              }
            }
          </div>

          <div class="form_group">
            <mat-form-field appearance="fill">
              <input
                matInput
                placeholder="{{ 'State' | translate }} ({{ 'Optional' | translate }})"
                class="form_control"
                formControlName="state" />
            </mat-form-field>
            @if (submitted) {
              @if (
                profileFormGroup
                  .get('address')
                  ?.get('state')
                  ?.hasError('required')
              ) {
                <mat-error>
                  {{ 'State' | translate }} {{ 'isRequired' | translate }}
                </mat-error>
              }
            }
          </div>

          <div class="form_group">
            <mat-form-field appearance="fill">
              <input
                matInput
                placeholder="{{ 'City' | translate }} ({{ 'Optional' | translate }})"
                class="form_control"
                formControlName="city" />
            </mat-form-field>
            @if (submitted) {
              @if (
                profileFormGroup
                  .get('address')
                  ?.get('city')
                  ?.hasError('required')
              ) {
                <mat-error>
                  {{ 'City' | translate }} {{ 'isRequired' | translate }}
                </mat-error>
              }
            }
          </div>



        </ng-container>
      </div>
      <div class="form_btn">
        <button class="btn btn_primary" type="submit">
          {{ 'Continue' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
